import config from "@/config";
import { useSelection } from "@frend-digital/centra/client";
import { ProductPricesWithDiscount } from "@frend-digital/centra/types";

const defaultPriceList = config.priceListId;

const emptyPrice: ProductPricesWithDiscount = {
  pricelistId: "",
  price: "",
  priceAsNumber: 0,
  priceBeforeDiscount: "",
  priceBeforeDiscountAsNumber: 0,
  discountPercent: 0,
  productOnSale: false,
};

const getPriceList = (
  prices?: ProductPricesWithDiscount | ProductPricesWithDiscount[],
  priceList: number | string = defaultPriceList,
): ProductPricesWithDiscount => {
  if (!prices) return emptyPrice;
  if (typeof priceList === "string") priceList = parseInt(priceList);
  if (!Array.isArray(prices)) {
    return prices;
  }

  const foundPriceList = prices.find(
    p => p.pricelistId?.toString() === priceList.toString(),
  );

  if (foundPriceList) {
    return foundPriceList;
  }

  if (prices.length === 1 && prices[0]) {
    return prices[0];
  }

  return emptyPrice;
};

const usePriceList = (
  prices?: ProductPricesWithDiscount | ProductPricesWithDiscount[],
) => {
  const { data: selection } = useSelection();
  const price = getPriceList(prices, selection?.location?.pricelist);

  return price;
};

export default usePriceList;
